import React from "react";
import { InputRangeRow } from "./index";
// Used on Heli KV2008B and Heli KV2019B Twisters

export default function AccelerationTimeRow() {
   return (
      <InputRangeRow
         titleProp={"Acceleration Time"}
         descriptionProp={"secs"}
         sizeProp={6}
         colSizeProp={6}
         typeProp={"text"}
         minProp={5}
         maxProp={120}
         propertyNameProp={"acceleration"}
         errorDialogueProp={"5-120 only"}
         floatProp={false}
      />
   );
}
